import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderBy',
    standalone: false
})
export class OrderByPipe implements PipeTransform {
    transform(array: Array<any>, args: any): Array<any> {
        return array?.sort((a, b) => a[args].localeCompare(b[args]));
    }
}
